import { createSelector } from 'reselect';
import { flow, property, some } from 'lodash';
import { moment } from 'utils';
import DateFormats from 'constants/DateFormats';

const objectSelectorFactory = (selector) =>
  createSelector(selector, (object) => ({
    data: object.get('data'),
    loading: object.get('loading'),
    error: object.get('error'),
  }));
export const slotsObjectSelector = objectSelectorFactory(property('contacts.slots'));
export const externalTaxAuthoritySelector = objectSelectorFactory(
  property('contacts.externalTaxAuthority'),
);
export const managementsSelector = objectSelectorFactory(property('contacts.managements'));
export const taxAuthoritiesSelector = objectSelectorFactory(property('contacts.taxAuthorities'));
export const taxAuthorityAffiliatesSelector = objectSelectorFactory(
  property('contacts.taxAuthorityAffiliates'),
);
export const servicesSelector = objectSelectorFactory(property('contacts.services'));
export const makeAppointmentSelector = objectSelectorFactory(property('contacts.makeAppointment'));
export const slotsDatesSelectors = createSelector(slotsObjectSelector, ({ data }) => {
  if (data) {
    return Object.keys(data).map((day) => moment(day, DateFormats.long).toDate());
  }
  return [];
});
export const propertySelectorFactory = (selector, propertyPath) =>
  flow(selector, property(propertyPath));

export const isAppointmentError = createSelector(
  [
    propertySelectorFactory(slotsObjectSelector, 'error'),
    propertySelectorFactory(externalTaxAuthoritySelector, 'error'),
    propertySelectorFactory(managementsSelector, 'error'),
    propertySelectorFactory(taxAuthoritiesSelector, 'error'),
    propertySelectorFactory(taxAuthorityAffiliatesSelector, 'error'),
    propertySelectorFactory(servicesSelector, 'error'),
  ],
  (...isErrors) => some(isErrors, (isError) => isError),
);
